<script setup lang="ts">
import '@formkit/themes/genesis'
import { appName } from '~/constants'
import { useAuthStore } from '~/stores/auth'
import { useSentry } from '~/composables/useSentry'
import { NConfigProvider } from 'naive-ui'
import { THEME_OVERRIDES } from '~/constants/theme'

const authStore = useAuthStore()
const { identifyUser } = useSentry()

const user = computed(() => authStore.user)

watch(user, (newUser) => {
  identifyUser(newUser)
}, {
  immediate: true,
  deep: true,
})

useHead({
  titleTemplate: titleChunk => titleChunk ? `${titleChunk} • ${appName}` : appName,
})
</script>

<template>
  <VitePwaManifest />
  <n-config-provider :theme-overrides="THEME_OVERRIDES">
    <NuxtLayout>
      <NuxtPage />
      <Alerts />
    </NuxtLayout>
  </n-config-provider>
</template>
